export const LOAN_TYPES = [
  'Personal Loan',
  'Home Loan',
  'Business Loan',
  'Education Loan',
  'Agriculture Loan',
  'Women Group Loan',
  'Property Loan',
  'Shop Loan',
  'Flat Loan',
  'Complex Loan',
  'ITR Loan',
  'Payslip Loan'
];

export const LOAN_SERVICES = [
  {
    title: 'Agriculture Loan',
    description: 'Increase your agriculture productivity with Laxmi Finsec Consultant Pvt. Ltd. Private Limited agriculture loan.',
    image: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=800',
    link: '/agriculture-loan'
  },
  {
    title: 'Business Loan',
    description: 'Grow your business with Laxmi Finsec Consultant Pvt. Ltd. Private Limited business loan.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800',
    link: '/business-loan'
  },
  {
    title: 'Personal Loan',
    description: 'Fulfill your daily needs with Laxmi Finsec Consultant Pvt. Ltd. Private Limited personal loan.',
    image: 'https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?w=800',
    link: '/personal-loan'
  },
  {
    title: 'Education Loan',
    description: 'Dreams come true with Laxmi Finsec Consultant Pvt. Ltd. Private Limited education loan.',
    image: 'https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?auto=format&fit=crop&w=1200&q=80',
    link: '/education-loan'
  },
  {
    title: 'Project Loan',
    description: 'Empowering your ambitions with tailored project financing solutions from Laxmi Finsec Consultant Pvt. Ltd.',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800',
    link: '/project-loan'
  },
  {
    title: 'Home Loan',
    description: 'Build your dream home with Laxmi Finsec Consultant Pvt. Ltd. Private Limited home loan.',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800',
    link: '/home-loan'
  }
];

export const TESTIMONIALS = [
  {
    text: 'We are completely satisfied with the quality of service that we get. Workers were respectful, efficient, accommodating, cleaned up thoroughly.',
    author: 'Santosh Kumar'
  },
  {
    text: 'They fulfill their commitment on time. We are very happy to get that quality service.',
    author: 'Komal Singh'
  },
  {
    text: 'They assist me for everything required for the loan. I am very happy because I got the loan when I need the most.',
    author: 'Savita Singh'
  }
];

export const CONTACT_INFO = {
  phone: '(+91) 9196086499',
  email: 'laxmifinsecconsultantpvt.ltd@gmail.com',
  address: '2nd Floor Shri Ram Complex, Railway Station Road, Ghazipur (233001) U.P.',
  whatsapp: '9196086499'
};